@use 'vars';

.password-input {
  &__adornment-container {
    display: flex;
    gap: vars.$gap-small;
  }
}
